import TemplateView from '../../../../../TemplateView'
import messageResource from '../../../../../messageResource'
import CardDetailsForm from '../../creditCard/CardDetailsForm'
import CardDetailsFooter from '../../creditCard/CardDetailsFooter'
import {CardBrandType} from '../../../constants'

export default class CreditCardContent extends TemplateView {
    constructor({
        showCheckbox = true,
        fieldsChangeAction = () => {},
        setStripeFieldsValid = () => {},
        addressFormOpenToggleAction = () => {},
        saveCardCheckboxCallback = () => {},
    }) {
        super()

        this.actions = {
            fieldsChangeAction,
            setStripeFieldsValid,
            addressFormOpenToggleAction,
        }

        this.params = {
            showCheckbox,
        }

        this.callbacks = {
            saveCardCheckboxCallback,
        }

        this.state = {
            cardType: CardBrandType.NONE,
            cardNumber: '',
            holderName: '',
            expiredMonth: '',
            expiredYear: '',
            address: '',
            city: '',
            zip: '',
            country: '',
            state: '',
            countries: [],
            statesByCountry: {},
            editable: false,
            isAddressFormOpen: false,
            showCheckbox: showCheckbox,
            haveSavedCard: false,
            needToSaveCard: false,
        }

        this.onAnyStatePropertyChanged(['haveSavedCard', 'editable'], () => {
            const checkboxTextKey = this.state.haveSavedCard
                                    ? 'licenses.card_details.footer.checkbox.text.extra'
                                    : 'licenses.card_details.footer.checkbox.text'

            this.footer.setState({
                checkboxText: messageResource.getMessage(checkboxTextKey),
                showCheckbox: !this.state.haveSavedCard || this.state.editable
            })

            this.content.setState({
                disabled: this.state.haveSavedCard && !this.state.editable,
            })
        })

        this.onAnyStatePropertyChanged([
            'cardType',
            'cardNumber',
            'holderName',
            'expiredMonth',
            'expiredYear',
            'address',
            'city',
            'zip',
            'country',
            'state',
            'countries',
            'statesByCountry',
            'editable',
            'isAddressFormOpen',
            'showCheckbox'
        ], () => {
            this.content.setState({
                cardType: this.state.cardType,
                cardNumber: this.state.cardNumber,
                holderName: this.state.holderName,
                expiredMonth: this.state.expiredMonth,
                expiredYear: this.state.expiredYear,
                address: this.state.address,
                city: this.state.city,
                zip: this.state.zip,
                country: this.state.country,
                state: this.state.state,
                countries: this.state.countries,
                statesByCountry: this.state.statesByCountry,
                editable: this.state.editable,
                isAddressFormOpen: this.state.isAddressFormOpen,
                showCheckbox: this.state.showCheckbox,
            })
        })

        this.onStatePropertyChanged('needToSaveCard', (needToSaveCard) => {
            this.footer.setState({
                checked: needToSaveCard
            })
        })
    }

    templateHtml() {
        return '<div class="creditCard">' +
               '    <div class="cardDetailsContainer"/>' +
               '    <div class="footerContainer"/>' +
               '</div>'
    }

    afterRender() {
        this.content = new CardDetailsForm({
            fieldsChangeCallback: this.actions.fieldsChangeAction,
            countriesList: this.params.countriesList,
            setStripeFieldsValid: this.actions.setStripeFieldsValid,
            toggleAddressFormCallback: this.actions.addressFormOpenToggleAction,
        }).init(this.find('.cardDetailsContainer'))

        this.footer = new CardDetailsFooter({
            showCheckbox: this.state.showCheckbox,
            saveCardCheckboxCallback: this.callbacks.saveCardCheckboxCallback,
        }).init(this.find('.footerContainer'))

        this.renderInitialState()
    }

    getStripeElements() {
        return this.content.getStripeElements()
    }

    clearStripeElements() {
        return this.content.clearStripeElements()
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/paymentStep/CreditCardContent.js